import {Component, Input, OnInit} from '@angular/core';
import {Device} from "../../model/device.model";
import {ModbusService} from "../../modbusrtu/modbus.service";
import {UtilService} from "../../shared/util.service";

@Component({
    selector: 'app-device-query',
    templateUrl: './device-query.component.html',
    standalone: false
})
export class DeviceQueryComponent implements OnInit {

  @Input() device: Device;

  MAX_UINT = 65536;
  REGISTER_ADHOC = 21;

  config: any = {};

  result: any;
  status: any;

  queryData = [];
  statusData = [];

  uptime: any;
  uptimeOS: any;
  uptime2: any;

  ip: any;

  constructor(
    private service: ModbusService,
    private util: UtilService
  ) { }
  ngOnInit(): void {
  }

  onClickPingBtn() {
    const ip = this.device.getIP();

    if (ip) {
      this.service.ping(ip).subscribe((resp:any) => {
        if (resp.error) {
          return this.service.notiService.open(resp.error);
        }
        this.status = resp;
        this.extractPingData();
      })
    } else {
      this.service.notiService.open("Can not find IP in device attributes");
    }
  }

  onClickBtn() {
    this.service.query(this.device.getQueryInfo()).subscribe((resp:any) => {
      if (resp.error) {
        return this.service.notiService.open(resp.error);
      }
      this.result = resp;
      if (this.device.isDatalogger()) {
        this.extractQueryData();
      } else {
        this.extractMeterData();
      }
    })
  }

  onClickAdhocBtn() {
    const ip = this.device.getIP();

    if (ip) {
      this.service.write(ip, this.REGISTER_ADHOC, 1, this.device.id).subscribe((resp:any) => {
        if (resp.error) {
          return this.service.notiService.open(resp.error);
        }
        this.service.notiService.open("Successful writing");
        console.log("write res", resp);
      })
    }
  }

  readUptimes() {
    let seconds = this.result.uptime_10 * this.MAX_UINT + this.result.uptime_9;
    let secondsOS = (this.result.uptime_os_12 * this.MAX_UINT) + this.result.uptime_os_11;
    let uptime = this.util.secondsToDhms(seconds);
    let uptimeOS = this.util.secondsToDhms(secondsOS);

    this.queryData.push({name: 'Uptime', value: uptime});
    this.queryData.push({name: 'Uptime OS', value: uptimeOS});
  }

  readIP() {
    let ip1 = this.util.get8bitsfrom16bit(this.result.ip_1);
    let ip2 = this.util.get8bitsfrom16bit(this.result.ip_2);
    let ip = [...ip1, ...ip2].join('.');

    this.queryData.push({name: 'IP', value: ip})
  }

  readUsername() {
    let uname1 = this.util.get8bitsfrom16bit(this.result.username_22);
    let uname2 = this.util.get8bitsfrom16bit(this.result.username_23);
    let uname3 = this.util.get8bitsfrom16bit(this.result.username_24);
    let uname4 = this.util.get8bitsfrom16bit(this.result.username_25);
    let uname5 = this.util.get8bitsfrom16bit(this.result.username_26);
    let uname6 = this.util.get8bitsfrom16bit(this.result.username_27);
    let uname7 = this.util.get8bitsfrom16bit(this.result.username_28);
    let uname8 = this.util.get8bitsfrom16bit(this.result.username_29);
    let uname9 = this.util.get8bitsfrom16bit(this.result.username_30);
    let nameDecimals = [...uname1, ...uname2, ...uname3, ...uname4, ...uname5, ...uname6, ...uname7, ...uname8, ...uname9];
    let username = nameDecimals.map(dec => String.fromCharCode(dec)).join('');

    this.queryData.push({name: 'Username', value: username})
  }

  extractQueryData() {
    this.queryData = [];
    this.readUptimes();
    this.readIP();
    this.queryData.push({name: 'Port', value: this.result.port_3})
    this.readUsername();
  }

  extractMeterData() {
    this.queryData = [];
    this.queryData.push({name: 'Product ID', value: this.result.product_id})
    this.queryData.push({name: 'Serial Reverse', value: this.result.serial_reverse})
  }

  extractPingData() {
    this.statusData = [];
    this.statusData.push({name: "IP", value: this.status.ip})
    this.statusData.push({name: "Online", value: this.status.online})
    this.statusData.push({name: "Latecy", value: this.status.latecy})
  }
}
